export default "__VITE_ASSET__BAMMEt8g__"